/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const _ = require('lodash');
const logger = require('@gral/log');
const k = require('@gral/constants');
const act = require('../actions/actDispatcher');
const Action = require('../actions/action');

const log = logger('ACT: SERVER');

const _relayNewAction = (type, data) => act.relay(new Action({ type, data, source: k.actionSources.SERVER }));

module.exports = {
  relay(action) {
    return act.relay(action);
  },
  fetchSuccess(msg) {
    log.info(`#${Action.seq()}: Fetch succeeded: ${msg.url} on ${msg.meta.dataPath}`);
    return _relayNewAction('FETCH_SUCCESS', msg);
  },

  serverError(error) {
    log.info(`#${Action.seq()}: Server error: ${error}`);
    return _relayNewAction('SERVER_ERROR', error);
  },

  fetchError(msg) {
    log.info(`#${Action.seq()}: Fetch failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('FETCH_ERROR', msg);
  },
  pushSuccess(msg) {
    log.info(`#${Action.seq()}: Push succeeded: ${msg.url}`);
    return _relayNewAction('PUSH_SUCCESS');
  },
  pushError(msg) {
    log.info(`#${Action.seq()}: Push failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('FETCH_ERROR', msg);
  },
  updateSuccess(msg) {
    log.info(`#${Action.seq()}: Update succeeded: ${msg.url}`);
    return _relayNewAction('UPDATE_SUCCESS', msg);
  },
  updateError(msg) {
    log.info(`#${Action.seq()}: Update failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('UPDATE_ERROR', msg);
  },
  createSuccess(msg) {
    log.info(`#${Action.seq()}: Create succeeded: ${msg.url}`);
    return _relayNewAction('CREATE_SUCCESS', msg);
  },
  createError(msg) {
    log.info(`#${Action.seq()}: Create failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('CREATE_ERROR', msg);
  },
  copySuccess(msg) {
    log.info(`#${Action.seq()}: Copy succeeded: ${msg.url}`);
    return _relayNewAction('COPY_SUCCESS', msg);
  },
  copyError(msg) {
    log.info(`#${Action.seq()}: Copy failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('COPY_ERROR', msg);
  },
  checkInOutSuccess(msg) {
    log.info(`#${Action.seq()}: Check in/out succeeded: ${msg.url}`);
    return _relayNewAction('CHECK_IN_OUT_SUCCESS', msg);
  },
  checkInOutError(msg) {
    log.info(`#${Action.seq()}: Check in/out failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('CHECK_IN_OUT_ERROR', msg);
  },
  createEventSuccess(msg) {
    log.info(`#${Action.seq()}: Create event succeeded: ${msg.url}`);
    return _relayNewAction('CREATE_EVENT_SUCCESS', msg);
  },
  createEventError(msg) {
    log.info(`#${Action.seq()}: Create event failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('CREATE_EVENT_ERROR', msg);
  },

  linkLayerToViewSuccess(msg) {
    log.info(`#${Action.seq()}: Link layer to view succeeded: ${msg.url}`);
    return _relayNewAction('LINK_LAYER_TO_VIEW_SUCCESS', msg);
  },
  linkLayerToViewError(msg) {
    log.info(`#${Action.seq()}: Link layer to view failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('LINK_LAYER_TO_VIEW_ERROR', msg);
  },
  unlinkLayerFromViewSuccess(msg) {
    log.info(`#${Action.seq()}: Unlink layer from view succeeded: ${msg.url}`);
    return _relayNewAction('UNLINK_LAYER_FROM_VIEW_SUCCESS', msg);
  },
  unlinkLayerFromViewError(msg) {
    log.info(`#${Action.seq()}: Unlink layer from view failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('UNLINK_LAYER_FROM_VIEW_ERROR', msg);
  },

  linkRulesetToLayerSuccess(msg) {
    log.info(`#${Action.seq()}: Link ruleset to layer succeeded: ${msg.url}`);
    return _relayNewAction('LINK_RULESET_TO_LAYER_SUCCESS', msg);
  },
  linkRulesetToLayerError(msg) {
    log.info(`#${Action.seq()}: Link ruleset to layer failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('LINK_RULESET_TO_LAYER_ERROR', msg);
  },
  unlinkRulesetFromLayerSuccess(msg) {
    log.info(`#${Action.seq()}: Unlink ruleset from layer succeeded: ${msg.url}`);
    return _relayNewAction('UNLINK_RULESET_FROM_LAYER_SUCCESS', msg);
  },
  unlinkRulesetFromLayerError(msg) {
    log.info(`#${Action.seq()}: Unlink ruleset from layer failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('UNLINK_RULESET_FROM_LAYER_ERROR', msg);
  },

  attachDeviceSuccess(msg) {
    log.info(`#${Action.seq()}: Attach device succeeded: ${msg.url}`);
    return _relayNewAction('ATTACH_DEVICE_SUCCESS', msg);
  },
  attachDeviceError(msg) {
    log.info(`#${Action.seq()}: Attach device  failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('ATTACH_DEVICE_ERROR', msg);
  },

  detachDeviceSuccess(msg) {
    log.info(`#${Action.seq()}: Detach device succeeded: ${msg.url}`);
    return _relayNewAction('DETACH_DEVICE_SUCCESS', msg);
  },
  detachDeviceError(msg) {
    log.info(`#${Action.seq()}: Detach device failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('DETACH_DEVICE_ERROR', msg);
  },

  attachSensorSuccess(msg) {
    log.info(`#${Action.seq()}: Attach sensor succeeded: ${msg.url}`);
    return _relayNewAction('ATTACH_SENSOR_SUCCESS', msg);
  },
  attachSensorError(msg) {
    log.info(`#${Action.seq()}: Attach sensor failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('ATTACH_SENSOR_ERROR', msg);
  },

  detachSensorSuccess(msg) {
    log.info(`#${Action.seq()}: Detach sensor succeeded: ${msg.url}`);
    return _relayNewAction('DETACH_SENSOR_SUCCESS', msg);
  },
  detachSensorError(msg) {
    log.info(`#${Action.seq()}: Detach sensor failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('DETACH_SENSOR_ERROR', msg);
  },

  unsetParameterSuccess(msg) {
    log.info(`#${Action.seq()}: Unset parameter succeeded: ${msg.url}`);
    return _relayNewAction('UNSET_PARAMETER_SUCCESS', msg);
  },
  unsetParameterError(msg) {
    log.info(`#${Action.seq()}: Unset parameter failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('UNSET_PARAMETER_ERROR', msg);
  },

  decommissionSuccess(msg) {
    log.info(`#${Action.seq()}: Unset parameter succeeded: ${msg.url}`);
    return _relayNewAction('UNSET_PARAMETER_SUCCESS', msg);
  },
  decommissionError(msg) {
    log.info(`#${Action.seq()}: Unset parameter failed: ${JSON.stringify(msg.errors)}`);
    return _relayNewAction('UNSET_PARAMETER_ERROR', msg);
  },

  uploadSuccess(msg) {
    log.info(`#${Action.seq()}: Upload completed successfully`);
    return _relayNewAction('UPLOAD_SUCCESS', msg);
  },
  uploadError(msg) {
    log.info(`#${Action.seq()}: Upload failed`);
    return _relayNewAction('UPLOAD_ERROR', msg);
  },

  getSettingsSuccess(sessionAttrs) {
    log.info(`#${Action.seq()}: Load settings succeeded`);
    return _relayNewAction('GET_SETTINGS_SUCCESS', sessionAttrs);
  },

  // getSettings(sessionAttrs) {
  //   log.info(`#${Action.seq()}: Loading settings`);
  //   return _relayNewAction('GET_SETTINGS', sessionAttrs);
  // },

  loginSuccess(user) {
    log.info(`#${Action.seq()}: Login success: ${user.login}`);
    return _relayNewAction('LOGIN_SUCCESS', user);
  },

  loginError(exception) {
    log.info(`#${Action.seq()}: Login failed: ${JSON.stringify(exception.message)}`);
    return _relayNewAction('LOGIN_ERROR', exception);
  },
  /*   refreshToken() {
    log.info(`#${Action.seq()}: Refreshing token...`);
    return _relayNewAction('REFRESH_TOKEN', 'msg');
  }, */
  refreshTokenSuccess(msg) {
    log.info(`#${Action.seq()}: Refreshing token...`);
    return _relayNewAction('REFRESH_TOKEN_SUCCESS', msg);
  },

  refreshTokenError(msg) {
    log.info(`#${Action.seq()}: Refreshing token...`);
    return _relayNewAction('REFRESH_TOKEN_ERROR', msg);
  },

  passwordRecoverySuccess(data) {
    log.info(`#${Action.seq()}: Password recovery succeeded`);
    return _relayNewAction('PASSWORD_RECOVERY_SUCCESS', data);
  },

  passwordRecoveryError(data) {
    log.info(`#${Action.seq()}: Password recovery error`);
    return _relayNewAction('PASSWORD_RECOVERY_ERROR', data);
  },

  passwordResetSuccess(data) {
    log.info(`#${Action.seq()}: Password reset succeeded`);
    return _relayNewAction('PASSWORD_RESET_SUCCESS', data);
  },
  passwordResetError(data) {
    log.info(`#${Action.seq()}: Password reset error`);
    return _relayNewAction('PASSWORD_RESET_ERROR', data);
  },

  checkTokenError() {
    log.info(`#${Action.seq()}: Token has expired`);
    return _relayNewAction('CHECK_TOKEN_ERROR');
  },

  mqttConnect(msg) {
    log.info(`#${Action.seq()}: Connecting to MQTT...`);
    return _relayNewAction('MQTT_CONNECT', msg);
  },

  mqttConnectSuccess() {
    log.info(`#${Action.seq()}: Connected to MQTT successfully`);
    return _relayNewAction('MQTT_CONNECT_SUCCESS', {});
  },

  /*   mqttConnectErrorOldRemove(exception) {
    log.info(`#${Action.seq()}: Connecting to MQTT failed: ${JSON.stringify(exception.message)}`);
    return _relayNewAction('MQTT_CONNECT_ERROR', exception);
  }, */

  mqttRx(msg) {
    log.info(`#${Action.seq()}: MQTT received: ${msg.topic}`);
    return _relayNewAction('MQTT_RX', msg);
  },
};
